import FormInput from 'app/components/base/FormInput';
import builder from './builder';

export default builder({ FormInput });
